<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop' :option="option"
              :drillClickList="drillClickList" :drillDimList="drillDimList"></ChartNav>
  </div>
</template>

<script>
import create from "../../create";
import {split} from "lodash-es";

export default create({
  name: "radar",
  data() {
    return {
      /* formatter: (params, data) => {
        let content = '';
        if (!this.option.tipContent) {
          this.option.tipContent = ['维度值', '指标名', '指标值']
        }
        if (this.option.tipContent?.includes('维度值')) {
          content += `<div>${params.name}</div>`
        }
        params.value.forEach(item => {
          content += '<div>'
          if (this.option.tipContent?.includes('指标值')) {
             const unit = this.getUnit(item.seriesName)
            content += `${item}`
          }
          content += '</div>'
        })
        return content
      }, */
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  x2() {
    return this.option.gridX2 || '80%';
  },
  methods: {
    // 获取单位
    getUnit(name) {
      const fieldItem = this.prop.metrics?.find(item => item.name === name || item.fieldName === name) || {}
      if (fieldItem?.set?.type === 'percent') {
        return '%'
      }
      return fieldItem?.set?.indexUnit || ''
    },
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    updateChart() {
      const {
        chartSet: {
          axisTitleSet = {}, // 轴标题对应name
          axisLabelSet = {}, // 轴标签
          splitLineBorderType = '', // 网格线类型
          splitLineSet = {}, // 网格线
          yAxisSet = {}, // 轴线
        },
        fontFamily = ''
      } = this.themeCfg
      const optionData = this.deepClone(this.dataChart);
      let series = optionData.series || []
      series = series[0] || {}
      series = series.data || []
      let splitColor = {
        color: []
      }
      let splitNumber = this.option.yAxisInterval || 2
      if (this.option.splitAreaColor || this.option.splitAreaColor2) {
        for (let i = 0; i < splitNumber; i++) {
          if (i % 2 === 0) {
            splitColor.color.push(this.option.splitAreaColor || '#fff')
          } else {
            splitColor.color.push(this.option.splitAreaColor2 || '#fff')
          }
        }
      } else {
        splitColor = {}
      }
//       兼容老版本 没有默认配置 设置为true
      if (!('splitAreaShow' in this.option)) {
        this.option.splitAreaShow = true
        splitColor = {}
      }
      const option = {
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip(),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(series),
        radar: {
          axisName: {
            show: this.option.showYAxisName || true,
            fontFamily: this.option.yAxisNameFontFamily || fontFamily,
            fontSize: this.option.yAxisNameFontSize || (axisTitleSet?.size || 12),
            color: this.option.yAxisNameColor || (axisTitleSet?.color || '#fff')
          },
          splitArea: {
            show: this.option.splitAreaShow,
            areaStyle: splitColor,
          },
          axisLabel: {
            show: this.validData(this.option.yAxisLabelShow, true),
            rotate: this.option.yAxisRotate,
            color: this.option.yAxisColor || (axisLabelSet?.color || "#fff"),
            fontSize: this.option.yAxisFontSize || (axisLabelSet?.size || 14),
            fontFamily: this.option.yAxisFontFamily || fontFamily

          },
          axisLine: {
            show: this.validData(this.option.yAxisLineShow, true),
            lineStyle: {
              color: this.option.yAxisLineColor || (yAxisSet?.color || "#fff"),
              width: this.option.yAxisLineWidth
            }
          },
          splitNumber: splitNumber,
          indicator: optionData.indicator?.map((i) => {
            return {
              ...i,
              color: this.option.indicatorColor || (axisLabelSet?.color || 'fff'),
            }
          }) || [],
          shape: this.option.shape || 'polygon',
          radius: this.option.radius || '75%',
          triggerEvent: true,
          splitLine: {
            show: this.validData(this.option.yAxisSplitLineShow, false),
            lineStyle: {
              type: this.option.yAxisSplitLineShowDotted ? [5, 8] : (splitLineBorderType || "solid"), //设置网格线类型 dotted：虚线   solid:实线
              color: this.option.yAxisSplitLineColor || (splitLineSet?.color || "#ccc"),
              width: this.option.yAxisSplitLineWidth || (splitLineSet?.size || 0),
            },
          }
        },
        series: (() => {
          const list = [
            {
              type: "radar",
              barWidth: this.option.barWidth || 16,
              barMinHeight: this.option.barMinHeight || 0,
              showSymbol: this.validData(this.option.symbolShow, false),
              symbol: this.option.symbolKind,
              symbolSize: this.option.symbolSize || 10,
              lineStyle: {
                width: this.option.lineWidth || 1
              },
              data: series.map((ele, index) => {
                let cfg = {
                  name: ele.name,
                  value: ele.value,
                  label: this.getOptionLabel({
                    position: this.option.labelPosition
                  }),
                  lineStyle: {
                    color: this.getColor(index)
                  },
                  itemStyle: {
                    barBorderRadius: this.option.barRadius || 0,
                    color: this.getColor(index)
                  },
                  areaStyle: (() => {
                    if (this.option.areaStyle) {
                      return {
                        opacity: this.option.areaOpacity || 0.9,
                      };
                    }
                  })(),
                }
                return cfg;
              })
            }
          ];
          return list;
        })()
      }
      if (this.isDataCenter) {
        let _op = this.getDimentionOption();
        if (_op.categories.length) {
          option.radar.indicator = _op.categories.map((it, idx) => {
            const dataList = _op.series.map(item => item.data[idx]?.value == '--' ? 0 : (item.data[idx]?.value * 1 || 0))

            const max = Math.max(...dataList)
            const min = Math.min(...dataList)

            let res = {
              name: it,
              max: Math.ceil(max / 9) * 10, // 最大值外扩10%
              min: this.option.yAxisMin,
              color: this.option.indicatorColor,
            }
            let opt = this.option.axisCustomSet || []
            let item = opt.find(el => el.metric === it)
            if (item) {
              res.min = item.min > min ? min * 0.9 : item.min
              res.max = item.max < max ? max * 1.1 : item.max;
            }

            return res
          });
          option.legend = this.getOptionLegend(_op.series);
          let _series = _op.series.map((el, index) => {
            let cfg = {
              name: el.name,
              value: el.data.map((i) => {
                return i.value
              }),
              label: this.getOptionLabel({
                position: this.option.labelPosition
              }),
              lineStyle: {
                color: this.getColor(index),
              },
              itemStyle: {
                barBorderRadius: this.option.barRadius || 0,
                color: this.getColor(index)
              },
              areaStyle: (() => {
                if (this.option.areaStyle) {
                  return {
                    opacity: this.option.areaOpacity || 0.9,
                  };
                }
              })(),
            }
            let cusItem
            if (this.option?.lineCustomSet?.length) {
              cusItem = this.option?.lineCustomSet.find(_el => _el.metric === el.code)
            }
            if (cusItem) {
              if (cusItem?.lineWidth) {
                cfg.lineStyle.width = cusItem?.lineWidth
              }
              if (cusItem?.showSymbol) {
                if (cusItem?.symbolKind) {
                  cfg.symbol = cusItem?.symbolKind
                }
                if (cusItem?.symbolSize) {
                  cfg.symbolSize = cusItem?.symbolSize
                }
              } else {
                cfg.symbol = 'none'
              }

              if (cusItem?.showArea) {
                cfg.areaStyle = {}
                if (cusItem?.areaOpacity) {
                  cfg.areaStyle.opacity = cusItem?.areaOpacity
                }
              } else {
                delete cfg.areaStyle
              }
            }
            return cfg;
          })
          if (this.option?.referenceCustomSet?.length) {
            this.option?.referenceCustomSet.forEach((el) => {
              _series.push({
                name: el.name,
                symbol: 'none',
                lineStyle: {
                  color: el.yAxisMarkLineColor,
                  width: el.yAxisMarkLineWidth,
                  type: el.yAxisMarkLineType
                },
                value: _series[0].value.map((i) => {
                  return this.getReferenceValue(el)
                })
              })
            })
          }
          option.series[0].data = _series;
        }
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    }
  }
});

</script>



